import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import "./i18n";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import App from "./App";
import { CompanyProvider } from "./context/CompanyContext.jsx";

const app = (
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
        }}
      >
        <AuthProvider>
          <CompanyProvider>
            <App />
          </CompanyProvider>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

const container = document.getElementById("root");

// index.html trae la portada ya pintada (scripts/prerender.mjs). En "/" React
// la retoma tal cual; en cualquier otra ruta se descarta y se monta la app.
if (window.location.pathname === "/" && container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  container.replaceChildren();
  document.documentElement.classList.remove("app-shell");
  createRoot(container).render(app);
}
